<template>
  <div ref="timeline" class="d-flex flex-column">
    <div v-for="item in items" :key="item.id" class="d-flex flex-row">
      <div class="date-column d-flex flex-column align-items-center">
        <span class="text-muted small">
          <slot name="date" :item="item"></slot>
        </span>
        <div class="timeline-connector"></div>
      </div>
      <div class="content-column flex-grow-1 ml-2">
        <slot name="content" :item="item"></slot>
      </div>
    </div>

    <div class="d-flex flex-row show-more-container">
      <div class="date-column"></div>
      <div class="ml-2">
        <a v-if="showMore" href="#" class="show-more-link" @click.prevent="$emit('show-more')">
          <b-icon icon="arrow-down-circle"></b-icon>&nbsp;Show more
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'UeTimeline',
  props: {
    items: {
      type: Array as PropType<Array<Record<string, unknown>>>,
      required: true,
    },
    showMore: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['show-more'],
})
</script>

<style lang="sass" scoped>
.date-column
  min-width: 96px

.timeline-connector
  width: 1px
  min-height: 32px
  border-right: 1px dashed var(--gray-500)
  margin-top: 4px
  flex-grow: 1
  margin-bottom: 4px
.show-more-link
  text-decoration: none

.content-column
  border-bottom: 1px solid rgba(0, 0, 0, 0.1)
  margin-bottom: 16px
  padding-bottom: 16px
.show-more-container
  min-height: 24px
</style>
